"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { CustomBreadcrumbs, Desktop, Mobile } from "ui"
import Container from "ui/Container"
import { BreadCrumbs, extractProperty } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: column;
    gap: 16px;
    padding-top: 48px;
  }
`
const StyledBreadcrumbsContainer = styled.div`
  padding: 0 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
  }
`
const StyledImageContainer = styled.div`
  position: relative;
  height: 166px;
  padding: 16px 16px 24px 16px;
  display: flex;
  align-items: flex-end;
  ${({ theme }) => theme.breakpoints.up("md")} {
    border-radius: 16px;
    padding: 32px;
    overflow: hidden;
    width: 100%;
    height: 300px;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(5, 23, 17, 0) 0%,
      rgba(5, 23, 17, 0.8) 100%
    );
    pointer-events: none;
    z-index: 1;
  }
`

export default function Hero({
  data,
  breadCrumbs,
}: {
  data: any
  breadCrumbs: BreadCrumbs
}) {
  const pageMainTitle = extractProperty(data, "pageMainTitle") as string
  const imageForDesktop = extractProperty(data, "imageForDesktop") as string
  const imageForMobile = extractProperty(data, "imageForMobile") as string
  return (
    <Container>
      <StyledContainer>
        <StyledBreadcrumbsContainer>
          <CustomBreadcrumbs breadcrumbs={breadCrumbs} />
        </StyledBreadcrumbsContainer>
        <StyledImageContainer>
          <div>
            <Desktop>
              <Image
                src={getUmbracoMediaUrl(imageForDesktop)}
                alt={""}
                fill
                style={{ objectFit: "cover", objectPosition: "50% 30%" }}
                priority
              />
            </Desktop>
            <Mobile>
              <Image
                src={getUmbracoMediaUrl(imageForMobile)}
                alt={pageMainTitle || "hero"}
                fill
                style={{ objectFit: "cover", objectPosition: "50% 30%" }}
                priority
              />
            </Mobile>
          </div>
          <Typography
            variant="h2"
            component="h1"
            style={{
              zIndex: 2,
              color: "white",
            }}
          >
            {pageMainTitle}
          </Typography>
        </StyledImageContainer>
      </StyledContainer>
    </Container>
  )
}
